<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="required ts-text-xs">{{
              $t('drawSetting.gameSetting')
            }}</label>
            <a-select
              v-model="model.game_setting_id"
              :options="game_settings"
              class="ts-w-full"
            ></a-select>
            <div
              class="validate ts-text-xs"
              v-if="errors.has('game_setting_id')"
            >
              {{ errors.first('game_setting_id') }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="required ts-text-xs">{{
              $t('drawSetting.prefix')
            }}</label>
            <a-select
              v-model="model.prefix_id"
              :options="game_prefixes"
              class="ts-w-full"
            ></a-select>
            <div class="validate ts-text-xs" v-if="errors.has('prefix_id')">
              {{ errors.first('prefix_id') }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="required ts-text-xs">{{
              $t('drawSetting.drawTime')
            }}</label>
            <a-time-picker
              v-model="model.draw_time"
              format="HH:mm"
              valueFormat="HH:mm"
              class="ts-w-full"
            />
            <div class="validate ts-text-xs" v-if="errors.has('draw_time')">
              {{ errors.first('draw_time') }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="required ts-text-xs">
              {{ $t('drawSetting.jackpot') }}
            </label>
            <input
              v-model.number="model.jackpot"
              type="number"
              step="any"
              class="form-control"
            />
            <small
              ><i>{{ $t('drawSetting.valueZeroUseToDefault') }}</i></small
            >
            <div class="validate ts-text-xs" v-if="errors.has('jackpot')">
              {{ errors.first('jackpot') }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <h3 class="ts-text-base ts-text-gray-500">
              {{ $t('drawSetting.dayOfweek') }}
            </h3>
            <div
              class="ts-w-full ts-border-2 ts-border-gray-200 ts-rounded-md ts-p-2"
            >
              <div class="ts-grid ts-grid-cols-3 ts-gap-3">
                <ts-checkbox v-model="model.monday" class="ts-text-xs">{{
                  $t('drawSetting.monday')
                }}</ts-checkbox>
                <ts-checkbox v-model="model.tuesday" class="ts-text-xs">{{
                  $t('drawSetting.tuesday')
                }}</ts-checkbox>
                <ts-checkbox v-model="model.wednesday" class="ts-text-xs">{{
                  $t('drawSetting.wednesday')
                }}</ts-checkbox>
                <ts-checkbox v-model="model.thurday" class="ts-text-xs">{{
                  $t('drawSetting.thursday')
                }}</ts-checkbox>
                <ts-checkbox v-model="model.friday" class="ts-text-xs">{{
                  $t('drawSetting.friday')
                }}</ts-checkbox>
                <ts-checkbox v-model="model.saturday" class="ts-text-xs">{{
                  $t('drawSetting.saturday')
                }}</ts-checkbox>
                <ts-checkbox v-model="model.sunday" class="ts-text-xs">{{
                  $t('drawSetting.sunday')
                }}</ts-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ts-checkbox v-model="model.is_active" class="ts-text-xs">{{
        $t('drawSetting.isActive')
      }}</ts-checkbox>
      <div class="row">
        <div class="col-md-12 ts-space-x-3 ts-flex ts-justify-end">
          <ts-button @click.prevent="$emit('close')">{{
            $t('cancel')
          }}</ts-button>
          <ts-button
            v-if="isEdit"
            color="primary"
            :waiting="updating"
            @click.prevent="onUpdate"
            >{{ $t('update') }}</ts-button
          >
          <div v-if="!isEdit">
            <ts-button
              class="mr-2"
              color="primary"
              outline
              :waiting="waiting_new"
              @click.prevent="onSaveNew"
              >{{ $t('save_add_new') }}</ts-button
            >
            <ts-button
              color="primary"
              :waiting="waiting"
              @click.prevent="onSave"
              >{{ $t('save') }}</ts-button
            >
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>
<script>
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'drawSettingCreateUpdate',
  data() {
    return {
      loading: false,
      waiting: false,
      waiting_new: false,
      updating: false,
      errors: new Errors(),
      game_settings: [],
      game_prefixes: [],
      model: {
        game_draw_setting_id: 0,
        game_setting_id: null,
        draw_time: moment().format('HH:mm'),
        prefix_id: null,
        jackpot: null,
        monday: false,
        tuesday: false,
        wednesday: false,
        thurday: false,
        friday: false,
        saturday: false,
        sunday: false,
        is_active: true,
      },
    }
  },
  created() {
    this.fetchData()
    this.setEditData()
  },
  computed: {
    ...mapState('administrator/drawSetting', ['edit_data']),
    isEdit() {
      return !_.isEmpty(this.$store.state.administrator.drawSetting.edit_data)
    },
  },
  methods: {
    ...mapActions('administrator/drawSetting', [
      'getGameSetting',
      'getGamePrefix',
      'store',
      'update',
    ]),
    async fetchData() {
      this.loading = true
      await this.getGameSetting().then((response) => {
        this.game_settings = response.data.map((el) => ({
          value: el.game_setting_id,
          label: el.game_setting,
        }))
      })
      await this.getGamePrefix()
        .then((response) => {
          this.game_prefixes = response.data.map((el) => ({
            value: el.prefix_id,
            label: el.prefix_sample,
          }))
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSave() {
      this.waiting = true
      this.store(this.model)
        .then((response) => {
          this.$toasted.success(response.message)
          this.$emit('close')
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onSaveNew() {
      this.errors = new Errors()
      this.waiting_new = true
      this.store(this.model)
        .then((response) => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    onUpdate() {
      this.errors = new Errors()
      this.updating = true
      this.update({
        id: this.model.game_draw_setting_id,
        data: this.model,
      })
        .then((response) => {
          this.$toasted.success(response.message)
          this.$emit('close')
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.updating = false
        })
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.game_draw_setting_id = this.edit_data.game_draw_setting_id
        this.model.game_setting_id = this.edit_data.game_setting_id
        this.model.draw_time = this.edit_data.draw_time
        this.model.prefix_id = this.edit_data.prefix_id
        this.model.jackpot = this.edit_data.jackpot
        this.model.monday = this.edit_data.monday
        this.model.tuesday = this.edit_data.tuesday
        this.model.wednesday = this.edit_data.wednesday
        this.model.thurday = this.edit_data.thursday
        this.model.friday = this.edit_data.friday
        this.model.saturday = this.edit_data.saturday
        this.model.sunday = this.edit_data.sunday
        this.model.is_active = this.edit_data.is_active
      }
    },
    clearInput() {
      this.model = {
        game_draw_setting_id: 0,
        game_setting_id: null,
        draw_time: moment().format('HH:mm'),
        prefix_id: null,
        jackpot: null,
        monday: false,
        tuesday: false,
        wednesday: false,
        thurday: false,
        friday: false,
        saturday: false,
        sunday: false,
        is_active: true,
      }
    },
  },
}
</script>